export default {
	title: 'Banner In Search',
};
